
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"29.222"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 0A27.971 27.971 0 00.579 7.834L0 8.392l4.441 4.626.583-.558a21.583 21.583 0 0129.961 0l.579.558 4.439-4.626-.579-.558A27.971 27.971 0 0020 0zm0 1.6a26.262 26.262 0 0117.679 6.888L35.461 10.8a22.952 22.952 0 00-30.92 0l-2.22-2.308A26.262 26.262 0 0120 1.6zm0 8.019a18.378 18.378 0 00-12.759 5.153l-.579.554 4.457 4.645.576-.558a11.906 11.906 0 0116.614 0l.576.558 4.456-4.644-.576-.554A18.392 18.392 0 0020 9.623zm0 1.6a16.685 16.685 0 0111.023 4.2l-2.236 2.327a13.285 13.285 0 00-17.572 0l-2.238-2.319A16.685 16.685 0 0120 11.226zm0 8.019a8.791 8.791 0 00-6.1 2.465l-.576.554 6.678 6.957.576-.6 6.1-6.356-.576-.554A8.791 8.791 0 0020 19.245zm0 1.6a7.052 7.052 0 014.31 1.569L20 26.899l-4.31-4.492A7.052 7.052 0 0120 20.849z","fill":"#38470b"}})])
          )
        }
      }
    